import styled from "styled-components";

const Container = styled.div`
  height: 100%;
`;

const Content = styled.div`
  margin-top: 22px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;

  > :not(:last-child) {
    margin-bottom: 16px;
  }
`;

export { Container, Content };
